import { render } from "./dprescription.vue?vue&type=template&id=523c9d1a&scoped=true"
import script from "./dprescription.vue?vue&type=script&lang=js"
export * from "./dprescription.vue?vue&type=script&lang=js"

import "./dprescription.vue?vue&type=style&index=0&id=523c9d1a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523c9d1a"]])

export default __exports__